import { createSlice } from "@reduxjs/toolkit";

interface IUiReducer {
  isSiteNavOpen: boolean;
}

const initialState: IUiReducer = {
  isSiteNavOpen: false,
};

const sliceUI = createSlice({
  initialState,
  name: "sliceUI",
  reducers: {
    toggleSiteNav(state) {
      state.isSiteNavOpen = !state.isSiteNavOpen;
    },
    openSideNav(state) {
      state.isSiteNavOpen = true;
    },
    closeSideNav(state) {
      state.isSiteNavOpen = false;
    },
  },
});
export const ReducerUI = sliceUI.reducer;
export const ActionUI = sliceUI.actions;
